import { memo } from "react";

import { InformationPage } from "../../common/components/informationPage/InformationPage";
import { IMG_EMPTY_STATE } from "../../utils/url/staticResources";
import { useTranslation } from "react-i18next";

const UserAccountsPlug = ({ manageUserLink }: { manageUserLink: string }) => {
  const { t } = useTranslation();
  return (
    <div className="scha__user-accounts__plug">
      <InformationPage
        title={<div className="display-small">{t("myCompany.plug.noUsers")}</div>}
        imageSrc={IMG_EMPTY_STATE}
        btnSetup={{
          id: "create-user-1",
          href: manageUserLink,
          label: t("userList.createNewUser"),
        }}
      />
    </div>
  );
};

export default memo(UserAccountsPlug);
